import { render } from "./Breadcrumbs.vue?vue&type=template&id=cacfcc2a"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=cacfcc2a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__